import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: 114,
    paddingTop: 80,
  },
  table: {
    padding: 24,
    overflow: "hidden",
    fontSize: 10,
  },
  statsWrapper: {
    display: "flex",
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },

  statCardItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(2),
    flex: 1,
  },

  statCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    padding: theme.spacing(2),
  },

  statLabel: {
    fontSize: "18px",
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  statValue: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },

  statDivider: {
    width: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(2, 0),
  },

  trendContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    height: 20, // Fixed height to prevent misalignment
  },

  trendText: {
    marginLeft: theme.spacing(0.5),
    fontSize: "12px",
    lineHeight: 1.2, // Ensures consistent line height
    whiteSpace: "nowrap", // Prevents text wrapping
  },
  usersAction: {
    textAlign: "right",
    marginBottom: 10,
  },
  spacer: {
    marginRight: 10,
  },
  bottomSpacer: {
    marginBottom: 15,
  },
  paddingSpacer: {
    paddingTop: 30,
  },
  dialogAction: {
    padding: "0 24px 24px 24px",
  },
  actionButton: {
    marginLeft: "24px !important",
  },
  dialogHeader: {
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
  },
  container: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: `calc(${window.innerHeight}px - 98px)`,
  },
  loader: {
    position: "absolute",
    background: "white",
    height: "calc(100% - 0px)",
    zIndex: 1500,
    opacity: 0.5,
    width: "100%",
    left: 0,
    top: 0,
  },
  error: {
    textAlign: "center",
    marginBottom: 15,
  },
  dialogSpacer: {
    padding: 16,
  },
  miniFieldBottom: {
    marginBottom: 22,
  },
  miniFieldGridBottom: {
    marginBottom: 10,
  },
  checkbox: { padding: "0 9px" },
}));
